var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-middle"},[_c('div',{staticClass:"btn"},[_c('p',{on:{"click":_vm.otherWay}},[_vm._v("其他方式支付")]),_c('p',{staticClass:"p1",on:{"click":_vm.getOrder}},[_vm._v("已完成支付")])])])}
var staticRenderFns = []

export { render, staticRenderFns }